import styled from 'styled-components';

export const Wrapper = styled.div``;

export const Items = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-template-rows: repeat(4, auto);
  gap: 8px;
  padding: 3px;
`;

export const Item = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
  cursor: pointer;
  padding: 5px;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 4px;
  }

  &.active {
    color: #1a98f1;
  }
`;

export const Title = styled.div``;

export const Count = styled.div`
  font-size: 11px;
  color: rgba(255, 255, 255, 0.3);
  position: relative;
  top: 3px;
`;
